import { BED_OPTIONS } from './beds'
import { BRIDGE } from './bridge-layout'

/** Bliss Basic overall bunk height used across the planner. */
export const BUNK_HEIGHT = 80

/** Vertical section of a Bliss Basic bunk, in inches, shared by the 3D model and 2D drawings. */
export function bunkProfile(h: number) {
  const lowerY = h * 0.13,
    upperY = h * 0.68,
    beamH = h * 0.085,
    mattressH = h * 0.075
  const guardBottom = upperY + mattressH + h * 0.035,
    guardH = Math.max(1, h * 0.1),
    ladderTop = guardBottom + guardH * 0.8
  const rungs = Array.from({ length: 5 }, (_, i) => ((upperY - 2) * (i + 1)) / 5)
  return { post: 3.5, lowerY, upperY, beamH, mattressH, guardBottom, guardH, ladderTop, ladderDepth: 3, rungs }
}

/** Actual 1×3 faces for three bars, or 1×4 faces for two bars, with 3½″ clear gaps. */
export function bunkGuardrailProfile(height: number, bars: 2 | 3) {
  const { upperY, mattressH } = bunkProfile(height)
  const face = bars === 3 ? 2.5 : 3.5
  const gap = 3.5
  const totalHeight = bars * face + (bars - 1) * gap
  // Keep the rail bottom fixed; extend the uprights instead of squeezing the gaps.
  const base = upperY + mattressH + gap
  return { face, gap, base, top: base + totalHeight }
}

/** Footprint length and mattress length for a Bliss Basic combination. */
export function bunkLengths(name: string) {
  const depth = BED_OPTIONS.find(o => o.name === name)?.depth ?? 82
  return { depth, mattress: depth - 2 * 3.5 }
}

/** Bliss 24-inch staircase: enclosed flight, 3″ cheeks, drawer in every step. */
export const STAIRCASE = {
  width: 24,
  run: BRIDGE.stairRun,
  height: 66,
  deck: BRIDGE.deckHeight,
  risers: BRIDGE.risers,
  cheek: 3,
  tread: 1,
} as const
